import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'

import Navigation from '@/components/Navigation'
import CopyrightBottom from '@/components/CopyrightBottom'
import ClassSelectList from '@/components/ClassSelectList'
import ClassSelectListHeader from '@/components/ClassSelectListHeader'
import ProductCard from '@/components/ProductCard'
import ImageViewer from '@/components/ImageViewer/ImageViewer'

import Author from '@/pages/author'
import Home from '@/pages/home'
import CompanyProfile from '@/pages/companyProfile'
import ContactUs from '@/pages/ContactUs'
import ProductList from '@/pages/productList'
import ProductClass from '@/pages/productClass'
import ProductInfo from '@/pages/productInfo'
import Questionnaire from '@/pages/questionnaire'
import profileDownload from '@/pages/profileDownload'


Vue.config.debug = true;

Vue.use(Router)
Vue.use(VueResource)

//注册组件
Vue.component('Navigation',Navigation);
Vue.component('CopyrightBottom',CopyrightBottom);
Vue.component('ClassSelectList',ClassSelectList);
Vue.component('ProductCard',ProductCard);
Vue.component('ImageViewer',ImageViewer);
Vue.component('ClassSelectListHeader', ClassSelectListHeader);
//注册路由
 export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        title: '首页'
      }
    },
    {
      path:'/author',
      name:'Author',
      component:Author,
      meta:{
        title:'用户登录'
      }
    },
    {
      path:'/companyprofile',
      name:'introduction',
      component:CompanyProfile,
      meta:{
        title:'公司简介'
      }
    },
    {
      path:'/contactUs',
      name:'contactUs',
      component:ContactUs,
      meta:{
        title:'联系我们'
      }
    },
    {
      path:'/questionnaire',
      name:'questionnaire',
      component:Questionnaire,
      meta:{
        title:'调查问卷'
      }
    },
    {
      path:'/profiledownload',
      name:'profileDownload',
      component:profileDownload,
      meta:{
        title:'文件下载'
      }
    },
    {
      path:'/productlist',
      name:'productList',
      component:ProductList,
      meta:{
        title:"所有产品"
      }
    },{
      path:'/productclass/:class',
      name:'productClass',
      component:ProductClass,
      meta:{
        title:"产品分类"
      }
    },
    {
      path:'/productinfo/:id',
      name:'productinfo',
      component:ProductInfo,
      meta:{
        title:"产品介绍"
      }
    },
    {
      path: "/product:classname",
      name:'Index',
      redirect: function(to){
        let class_name = to.params.classname;
        console.log(class_name);
        if (class_name.length) {
          return "/productlist";
        }else{
          return "/productclass";
        }
      }
    }
  ]
})






// WEBPACK FOOTER //
// ./src/router/index.js